
import _ from 'underscore'
import $ from 'jquery'
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import FacadeMixin from './mixins/FacadeMixin'
import HitAreaCollection from '../collections/HitAreaCollection'
import LayerCollection from '../collections/LayerCollection'
import Level from '../facades/Level'
import TagsMixin from './mixins/TagsMixin'
import MapModelMixin from './mixins/MapModelMixin'
import UnitCollection from '../collections/UnitCollection'

class LevelModel extends Backbone.Model {

  defaults() {
    return {
      x: 0,
      y: 0,
      scale: 1.0,
      opacity: 1.0,
      visible: true,
      transition: {}
    }
  }

  initialize(attributes, options = {}) {
    this._facade = new Level(this)

    // Pass a reference of the LevelModel instance down through its children.
    
    options.levelModel = this

    this.set({x: 0, y: 0})
    this.set('units', new UnitCollection())
    this.set('hitareas', new HitAreaCollection())
    this.set('layers', new LayerCollection(this.get('elements'), options))
  }

  transition(properties, duration = 350, ease = 'cubic-in-out') {
    this.set('transition', {properties, duration, ease})
    return this
  }

  translate(x, y) {
    this.set({x: x, y: y})
    return this
  }

  scale(scale) {
    this.set('scale', scale)
    return this
  }

  show() {
    this.set('visible', true)
    return this
  }

  hide() {
    this.set('visible', false)
    return this
  }

  data() {
    let keys = ['id', 'uid', 'type', 'visible', 'x', 'y', 'tags']
    return _.pick(this.toJSON(), keys)
  }

  opacity(opacity) {
    this.set('opacity', opacity)
    return this
  }

  clone(id, tags = {}) {
    // Ensure the Level does not contain a UnitLayer or HitAreaLayer element
    // as apart of its children. If it does, return.

    let result = _.filter(this.get('elements'), (element) => {
      return element.type === 'UnitLayer' || element.type === 'HitAreaLayer'
    })

    if (result.length > 0) {
      return
    }

    // Clone the Level Object.
    
    let attributes = _.omit(this.attributes, ['units', 'hitareas', 'levels'])
    attributes.tags = attributes.tags ? _.assign(tags, attributes.tags) : tags
    attributes.id = attributes.uid = id

    // Create a new LevelModel instance for the cloned Level Object, add it 
    // to the MapModel's LevelCollection and return it.
    
    let model = new LevelModel(attributes)
    let mapLevels = this._mapModel.get('levels')
    
    mapLevels.add(model, {at: mapLevels.indexOf(this)})
    return model
  }
}

Cocktail.mixin(LevelModel, MapModelMixin, FacadeMixin, TagsMixin)

export default LevelModel
